export default {
  NEW(state, payload) {
    let currentTime = new Date().getTime()
    const toast = {
      id: currentTime,
      message: typeof payload === 'string' ? payload : payload.message,
      type: payload.type || 'default',
      duration: payload.duration || 5000,
      description: payload.description || null,
      sticky: payload?.sticky || false,
      timestamp: currentTime,
    }

    if (toast.type === 'error') {
      const existingToast = state.toastsList.find(
        (selectedtToast) =>
          selectedtToast.type === 'error' && currentTime - selectedtToast.timestamp < 2000,
      )

      if (existingToast) {
        if (!existingToast.message.includes(toast.message)) {
          existingToast.message += `; ${toast.message}`
        }
        existingToast.timestamp = currentTime
        return
      }
    }

    // Handle notification type specifically
    if (toast.type === 'notification') {
      toast.image = payload.image
      toast.related_user = payload.related_user
      toast.inserted_at = payload.inserted_at
    }

    // Add the new toast to the list
    state.toastsList.push({ ...toast })
  },
  REMOVE(state, payload) {
    state.toastsList = state.toastsList.filter(({ id }) => id !== payload.id)
  },
  CLEAR_LIST(state) {
    state.toastsList = []
  },
}
